import PillButton from "./PillButton";
import { Reveal } from "./Reveal";
import { useStaffing } from "../forms/StaffingProvider";

export default function CTASection({
  eyebrow = "Let's build together",
  title = "Ready to build what's next?",
  subtitle = "Talk to an AMVI expert about your technology, staffing or transformation goals.",
  testId = "cta-section",
}) {
  const { open } = useStaffing();
  return (
    <section className="relative overflow-hidden px-6 py-24 lg:py-32" data-testid={testId}>
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[700px] -translate-x-1/2 -translate-y-1/2 radial-glow" />
      <Reveal className="relative mx-auto max-w-4xl text-center">
        <div className="mb-5 text-xs font-medium uppercase tracking-[0.25em] text-sky-400">
          {eyebrow}
        </div>
        <h2 className="font-heading text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-400 lg:text-lg">
          {subtitle}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <PillButton to="/contact" size="lg" testId={`${testId}-talk`}>
            Talk to an Expert
          </PillButton>
          <PillButton
            variant="outline"
            size="lg"
            onClick={open}
            testId={`${testId}-staffing`}
          >
            Submit a Staffing Requirement
          </PillButton>
        </div>
      </Reveal>
    </section>
  );
}
